import cleanObject from '../helpers/clean-object'
export const useUserStore = defineStore('user', () => {
  const { $api } = useNuxtApp()
  const id = ref<any>(null)
  const uniqueId = ref<any>(null)
  const name = ref<any>(null)
  const email = ref<any>(null)
  const birthday = ref<any>(null)
  const phone = ref<any>(null)
  const newsletter = ref<any>(null)
  const picture = ref<any>(null)
  const country = ref<any>('nl-nl')
  const completedAccount = ref<boolean>(false)
  const showCompletedMessage = ref<boolean>(false)
  // user preferences
  const hideIndicationForever = ref<boolean>(false)
  const preferredShop = ref<string | null>(null)

  const setUserData = (payload: any) => {
    id.value = payload.id
    uniqueId.value = payload.uniqueId
    name.value = payload.name
    email.value = payload.email
    birthday.value = payload.birthday
    phone.value = payload.phone
    newsletter.value = payload.newsletter
    picture.value = payload.picture
    country.value = payload.country
    completedAccount.value = payload.completedAccount
    showCompletedMessage.value = payload.showCompletedMessage
  }

  const deleteUserData = () => {
    id.value =
      name.value =
      email.value =
      country.value =
      uniqueId.value =
      picture.value =
      phone.value =
      birthday.value =
      newsletter.value =
        null
  }

  const load = async () => {
    if (!id.value) { return }
    const data = await $api(`customers/${id.value}`)
    if (data) {
      await setUserData(data)
    }
  }

  const remove = async () => {
    if (!id.value) { return }
    const data = await $api(`customers/${id.value}`, { method: 'DELETE' })
    useAuthStore().logout()
    return data
  }

  const save = async () => {
    if (!id.value) { return }
    const data = await $api(
      `customers/${id.value}`,
      {
        method: 'PATCH',
        body:
          cleanObject({
          // Only returns non-empty properties
            name: name.value,
            birthday: birthday.value,
            phone: phone.value,
            newsletter: newsletter.value,
            picture: picture.value
          })
      }
    )

    if (data) {
      setUserData(data)
    }

    return data
  }

  const resetPassword = async ({ oldPassword, newPassword, newPasswordConfirm }: {oldPassword:string, newPassword:string, newPasswordConfirm: string}) => {
    if (!id.value) { return }
    return await $api(`customers/${id.value}`, {
      method: 'PATCH',
      body: {
        passwordOld: oldPassword,
        password: newPassword,
        passwordConfirmation: newPasswordConfirm
      }
    })
  }

  const countryShort = computed(() => country.value)

  const profilePicture = computed(() => {
    const runtimeConfig = useRuntimeConfig()
    if (!useAuthStore().loggedIn || !picture.value) { return false }
    return `${runtimeConfig.public.cdnURL}profile/${picture.value}.webp`
  })

  return {
    id,
    uniqueId,
    name,
    email,
    birthday,
    phone,
    newsletter,
    picture,
    country,
    completedAccount,
    showCompletedMessage,
    countryShort,
    profilePicture,
    hideIndicationForever,
    preferredShop,
    setUserData,
    deleteUserData,
    load,
    remove,
    save,
    resetPassword
  }
}, {
  persistedState: {
    persist: true
  }
})
